
import {PerformanceLogger} from '../performance';

const PAINT_TIMING_MAP = {
    'first-paint': 'fp',
    'first-contentful-paint': 'fcp',
};

// eslint-disable-next-line @typescript-eslint/ban-types
function isValidKey(key: string | number | symbol, object: object): key is keyof typeof object {
    return key in object;
}

export class FirstPaint {

    key = 'FirstPaint';

    logger: PerformanceLogger;


    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    getFirstPaintData() {
        const paintTimings = performance.getEntriesByType('paint');
        const paintData: {[key: string]: number} = {};
        paintTimings.forEach((data: PerformanceEntry) => {
            const name = data.name;
            if (isValidKey(name, PAINT_TIMING_MAP)) {
                const key = PAINT_TIMING_MAP[name];
                paintData[key] = data.startTime;
            }
        });
        return paintData;
    }

    getData() {
        const paintData = this.getFirstPaintData();
        return {
            type: this.key,
            ...paintData,
            origin: performance.getEntriesByType('paint'),
        };
    }
}
